import { Box } from "@chakra-ui/react";
import React from "react";
import styles from "./chip.module.css";

const Chip = (props) => {
  return (
    <div>
      <Box className={styles.chip} bg={props.bg || "#fff"} cursor={"pointer"}>
        {props.name}
      </Box>
    </div>
  );
};

export default Chip;
